import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function SrPropertyTypeLabel({ propertyType, isCircular }) {
  return (
    <span
      className={classnames(
        `SrPropertyTypeLabel ${(propertyType || '').toLowerCase()}`,
        isCircular && 'isCircular',
      )}
    >
      {propertyType}
    </span>
  );
}

SrPropertyTypeLabel.propTypes = {
  propertyType: PropTypes.string.isRequired,
};

SrPropertyTypeLabel.displayName = 'SrPropertyTypeLabel';

export default SrPropertyTypeLabel;
